import { render, staticRenderFns } from "./saleInvoiceApproval.vue?vue&type=template&id=5c0f92e2"
import script from "./saleInvoiceApproval.vue?vue&type=script&lang=js"
export * from "./saleInvoiceApproval.vue?vue&type=script&lang=js"
import style0 from "./saleInvoiceApproval.vue?vue&type=style&index=0&id=5c0f92e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports